import { Directive, ElementRef } from '@angular/core';
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import { OSM } from 'ol/source';

@Directive({
  selector: '[olMap]',
  host:{
    class: 'h-full w-full'
  }
})
export class MapDirective {
  private map!: Map;

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    this.map = new Map({
      target: this.el.nativeElement,
      layers: [
        new TileLayer({
          source: new OSM()
        })
      ],
      view: new View({
        center: [0, 0],
        zoom: 2
      })
    });
  }

  ngOnDestroy(): void {
    if (this.map) {
      this.map.setTarget(undefined);
    }
  }


}
